import { z } from "zod";
import { emailSchema } from "../common/email.js";

export const confirmEmailChangeSchema = z
	.object({
		new_email: emailSchema,
		code: z
			.string()
			.length(6, { message: "Code must be 6 digits" })
			.regex(/^\d{6}$/, { message: "Code must be 6 digits" }),
	})
	.strict();

export type ConfirmEmailChangePayload = z.infer<typeof confirmEmailChangeSchema>;
